<template>
  <span class="flex w-full items-center gap-1.5">
    <span>{{ label }}</span>
    <CurrentPeriodTag v-if="isCurrent" />
    <span class="ml-auto flex shrink-0 items-center gap-1">
      <button
        v-if="canSchedule"
        type="button"
        class="rounded border border-dashed border-gray-300 bg-white px-2 py-0.5 text-[11px] font-medium text-gray-500 hover:border-blue-400 hover:text-blue-700"
        :title="`Schedule into ${label}`"
        @click="emit('schedule')"
      >
        + Schedule
      </button>
      <button
        v-if="canOpenReport"
        type="button"
        class="flex items-center rounded border border-gray-300 bg-white p-1 text-gray-500 hover:border-blue-400 hover:text-blue-700"
        :title="`Capacity by customer · ${label}`"
        :aria-label="`Capacity by customer for ${label}`"
        @click="emit('openReport')"
      >
        <!-- Echoes the report's own donut. Inline rather than an icon font so it inherits
             the button's hover colour. -->
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
          <path d="M22 12A10 10 0 0 0 12 2v10z" />
        </svg>
      </button>
    </span>
  </span>
</template>

<script setup lang="ts">
  import CurrentPeriodTag from '@/components/capacity/CurrentPeriodTag.vue';

  defineProps<{ label: string; isCurrent: boolean; canSchedule: boolean; canOpenReport: boolean }>();
  const emit = defineEmits<{ schedule: []; openReport: [] }>();
</script>
